// extracted by mini-css-extract-plugin
export default {"container":"firstAndLastName_container__WLtnn"};